<template>
	<div class="services-industrial-internet-list">
		<div class="services-industrial-internet-con">
			<div class="title">
				<i class="x-icon-keys"></i><span
			class="x-tit-con">System Level Machining Accuracy Assurance Solution</span>
			</div>

			<div class="list">
				<div class="tt">
					<img :src="solution_image_01" alt="Xhorse"/>
				</div>
				<div class="dd">
					<ul class="item-two">
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Digital twin virtual factory;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Intelligent distribution and distribution of processing orders;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Real time monitoring of machining status;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Real time monitoring of equipment health status, etc;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Intelligent human-computer interaction;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Intelligent energy control system;</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">Robot automatic loading and unloading.</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_system_01.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
            };
        }
    }

</script>

<style scoped="">
	.dd > ul > li > h3 {
		font-family: "Open SB";
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.dd > ul > li > p {
		width: 100%;
		font-size: 1rem;
		color: #212525;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.ll {
		width: calc(100% - .625rem);
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
		text-align: left;
	}

	.dd > ul > li {
		width: 100%;
		margin-bottom: 1.5rem;
	}

	.dd > ul {
		width: 100%;
		height: 13.5rem;
		margin-top: 2.75rem;
	}

	.dd {
		margin-top: 2.75rem;
	}

	.tt > img {
		width: 100%;
		height: 20rem;
	}

	.tt {
		width: 100%;
		height: 20rem;
		border: none;
	}

	.list > .tt, .list > .dd {
		width: 100%;
	}

	.services-industrial-internet-con {
		width: 61.5rem;
		border: none;
		margin-left: 0px;
	}

	.services-industrial-internet-list {
		width: 61.5rem;
		height: 48.125rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-system-level-machining-accuracy-assurance.vue